import { createGenerateId, mergeDefaultProps } from "@kobalte/utils";
import { createUniqueId, splitProps } from "solid-js";
import { createDisclosureState } from "../primitives";
import { Menu } from "./menu";
import { MenuRootContext } from "./menu-root-context";
/**
 * Root component for a menu, provide context for its children.
 * Used to build dropdown menu, context menu and menubar.
 */
export function MenuRoot(props) {
    const defaultId = `menu-${createUniqueId()}`;
    const mergedProps = mergeDefaultProps({
        id: defaultId,
        modal: true,
    }, props);
    const [local, others] = splitProps(mergedProps, [
        "id",
        "modal",
        "preventScroll",
        "forceMount",
        "open",
        "defaultOpen",
        "onOpenChange",
        "value",
    ]);
    const disclosureState = createDisclosureState({
        open: () => local.open,
        defaultOpen: () => local.defaultOpen,
        onOpenChange: (isOpen) => local.onOpenChange?.(isOpen),
    });
    const context = {
        isModal: () => local.modal ?? true,
        preventScroll: () => local.preventScroll ?? context.isModal(),
        forceMount: () => local.forceMount ?? false,
        generateId: createGenerateId(() => local.id),
        value: () => local.value,
    };
    return (<MenuRootContext.Provider value={context}>
			<Menu open={disclosureState.isOpen()} onOpenChange={disclosureState.setIsOpen} {...others}/>
		</MenuRootContext.Provider>);
}
